(function ($) {
  var initializeBlock = function ($block) {
    function matchHeightFire() {
      $(".iconBox .iconBox__icon").matchHeight({ property: "min-height" });
      $(".iconBox .iconBox__content .contentStyled h1, .iconBox .iconBox__content .contentStyled h2, .iconBox .iconBox__content .contentStyled h3, .iconBox .iconBox__content .contentStyled h4, .iconBox .iconBox__content .contentStyled h5, .iconBox .iconBox__content .contentStyled h6, .iconBox .iconBox__content .contentStyled .paragraphContent").matchHeight({ property: "min-height" });
    }

    matchHeightFire();
    $(window).bind("resize orientationchange", function (event) {
        matchHeightFire();
    });
    setTimeout(function () {
        matchHeightFire();
    }, 1000);
  };

  $(document).ready(function () {
    $(".block--icon-boxes").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=icon-boxes",
      initializeBlock
    );
  }
})(jQuery);
